// extracted by mini-css-extract-plugin
export default {"box":"Dashboard_box__rnDhX","title":"Dashboard_title__33k4M","filter-panel":"Dashboard_filter-panel__FvpFo","features-list":"Dashboard_features-list__x85E1"};